import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import { IconButton, Tooltip } from '@mui/material';

export const AddButtonIcon = ({ onClick, title }: any) => {
  return (
    <Tooltip onClick={onClick} title={title}>
      <IconButton aria-label="add">
        <AddBoxRoundedIcon style={{ fill: '#22c55e', fontSize: '22px' }} />
      </IconButton>
    </Tooltip>
  );
};
